// import PropTypes from 'prop-types';
// import React, { createContext, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';

// // third-party
// import {
// 	createUserWithEmailAndPassword,
// 	signInWithEmailAndPassword,
// 	signOut,
// 	signInWithPopup,
// 	GoogleAuthProvider,
// 	FacebookAuthProvider
// } from 'firebase/auth';

// // action - state management
// import { setUser, selectUser, createUserAsync, getUserInfoAsync } from 'store/user/userSlice';

// // project imports
// import Loader from 'components/common/Loader';
// import { authFire } from 'dbServer/appFirebase';
// import { mapLoggedUserInfo } from './firebaseContextUtil';

// const initialState = {
// 	isLoggedIn: false,
// 	isInitialized: false,
// 	user: null
// };
// const FirebaseContext = createContext({
// 	...initialState,
// 	doCreateUserWithEmailAndPassword: () => Promise.resolve(),
// 	doSignInWithEmailAndPassword: () => Promise.resolve(),
// 	doLoginWithGoogle: () => Promise.resolve(),
// 	doLoginWithFacebook: () => Promise.resolve(),
// 	doLogout: () => Promise.resolve()
// });

// export const FirebaseProvider = ({ children }) => {
// 	const dispatch = useDispatch();
// 	const user = useSelector(selectUser);

// 	const manageLoggedUserInfo = async (loggedUser, signup) => {
// 		const mappedUser = mapLoggedUserInfo(loggedUser.user);
// 		if (signup) {
// 			dispatch(createUserAsync(mappedUser));
// 		} else {
// 			let loggedUser = await dispatch(getUserInfoAsync(mappedUser.uid)).unwrap();
// 			if (!loggedUser) {
// 				loggedUser = await dispatch(createUserAsync(mappedUser)).unwrap();
// 			}

// 			dispatch(setUser(loggedUser));
// 		}
// 		return loggedUser;
// 	};

// 	const doCreateUserWithEmailAndPassword = async userInfo => {
// 		const { email, password, fullName, displayName } = userInfo;

// 		const loggedUser = await createUserWithEmailAndPassword(authFire, email, password);
// 		await manageLoggedUserInfo({ ...loggedUser, user: { ...loggedUser.user, fullName, displayName } }, true);
// 	};

// 	// const doSignInWithEmailAndPassword = async ({ email, password }) => {
// 	// 	const loggedUser = await signInWithEmailAndPassword(authFire, email, password);
// 	// 	await manageLoggedUserInfo(loggedUser);
// 	// };

// 	const doSignInWithEmailAndPassword = async ({ email, password }) => {
//     const loggedUser = await signInWithEmailAndPassword(authFire, email, password);

//     await manageLoggedUserInfo(loggedUser);
// };

// 	const doLoginWithGoogle = async (signup = false) => {
// 		const loggedUser = await signInWithPopup(authFire, new GoogleAuthProvider());
// 		await manageLoggedUserInfo(loggedUser, signup);
// 	};

// 	const doLoginWithFacebook = () => {
// 		const provider = new FacebookAuthProvider();
// 		provider.setCustomParameters({
// 			display: 'popup'
// 		});
// 		return signInWithPopup(authFire, provider);
// 	};

// 	const doLogout = () => signOut(authFire);

// 	useEffect(() => {
// 		const unsubscribe = authFire.onAuthStateChanged(async fsUser => {
// 			if (!fsUser) {
// 				dispatch(
// 					setUser({
// 						isLoggedIn: false,
// 						user: null
// 					})
// 				);
// 			}
// 		});
// 		return unsubscribe;
// 	}, [dispatch]);

// 	if (!user.isInitialized) {
// 		return <Loader />;
// 	}

// 	return (
// 		<FirebaseContext.Provider
// 			value={{
// 				isLoggedIn: user.isLoggedIn,
// 				userId: user.info?.userId,
// 				doCreateUserWithEmailAndPassword,
// 				doSignInWithEmailAndPassword,
// 				doLoginWithGoogle,
// 				doLoginWithFacebook,
// 				doLogout
// 			}}>
// 			{children}
// 		</FirebaseContext.Provider>
// 	);
// };

// FirebaseProvider.propTypes = {
// 	children: PropTypes.node
// };

// export default FirebaseContext;

import PropTypes from 'prop-types';
import React, { createContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// third-party
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    signInWithPopup,
    GoogleAuthProvider,
    FacebookAuthProvider
} from 'firebase/auth';

// action - state management
import { setUser, selectUser, createUserAsync, getUserInfoAsync } from 'store/user/userSlice';

// project imports
import Loader from 'components/common/Loader';
import { authFire } from 'dbServer/appFirebase';
import { mapLoggedUserInfo } from './firebaseContextUtil';

const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null
};
const FirebaseContext = createContext({
    ...initialState,
    doCreateUserWithEmailAndPassword: () => Promise.resolve(),
    doSignInWithEmailAndPassword: () => Promise.resolve(),
    doLoginWithGoogle: () => Promise.resolve(),
    doLoginWithFacebook: () => Promise.resolve(),
    doLogout: () => Promise.resolve()
});

export const FirebaseProvider = ({ children }) => {
    const dispatch = useDispatch();
    const user = useSelector(selectUser);

    // This function is now ONLY used for creating a BRAND NEW user document in Firestore.
    const createNewUserInDb = async (firebaseUser) => {
        const mappedUser = mapLoggedUserInfo(firebaseUser);
        await dispatch(createUserAsync(mappedUser));
    };

    const doCreateUserWithEmailAndPassword = async userInfo => {
        const { email, password, fullName, displayName } = userInfo;
        const loggedUser = await createUserWithEmailAndPassword(authFire, email, password);
        // After creating the user in Auth, create their initial document in Firestore.
        // The onAuthStateChanged listener will then handle setting the Redux state.
        await createNewUserInDb({ ...loggedUser.user, fullName, displayName });
    };

    // --- THIS IS THE FIRST PART OF THE FIX ---
    // The login functions are now simplified. Their ONLY job is to tell Firebase to sign in.
    // They no longer manage the Redux state directly, which eliminates the race condition.
    const doSignInWithEmailAndPassword = ({ email, password }) => {
        return signInWithEmailAndPassword(authFire, email, password);
    };

    const doLoginWithGoogle = () => {
        return signInWithPopup(authFire, new GoogleAuthProvider());
    };

    const doLoginWithFacebook = () => {
        const provider = new FacebookAuthProvider();
        provider.setCustomParameters({ display: 'popup' });
        return signInWithPopup(authFire, provider);
    };

    const doLogout = () => signOut(authFire);

    // --- THIS IS THE SECOND, CRITICAL PART OF THE FIX ---
    useEffect(() => {
        // onAuthStateChanged is the SINGLE SOURCE OF TRUTH for the user's session.
        const unsubscribe = authFire.onAuthStateChanged(async fsUser => {
            if (!fsUser) {
                // This is correct: if Firebase has no user, log out of Redux and mark initialization as complete.
                dispatch(
                    setUser({
                        isLoggedIn: false,
                        user: null
                    })
                );
            } else {
                // If Firebase has a user, it means they are logged in.
                // We must now fetch their full profile from our Firestore database.
                const userFromDb = await dispatch(getUserInfoAsync(fsUser.uid)).unwrap();

                if (userFromDb) {
                    // If we found the user in our database, update the Redux state.
                    // This `userFromDb` object contains the correct `isAdmin` flag.
                    dispatch(
                        setUser({
                            isLoggedIn: true,
                            user: userFromDb
                        })
                    );
                } else {
                    // This handles a new user (e.g., from Google Sign-In) who exists in Auth
                    // but not in our database yet. So, we create them.
                    await createNewUserInDb(fsUser);
                    // After creation, onAuthStateChanged will fire again automatically, find the user
                    // in the DB this time, and log them in correctly.
                }
            }
        });
        return unsubscribe;
    }, [dispatch]);
    // --- END OF FIX ---

    // This guard is now critical. It shows a loader until the `useEffect` above
    // has finished its first check and set `isInitialized` to true.
    if (!user.isInitialized) {
        return <Loader />;
    }

    return (
        <FirebaseContext.Provider
            value={{
                isLoggedIn: user.isLoggedIn,
                userId: user.info?.userId,
                doCreateUserWithEmailAndPassword,
                doSignInWithEmailAndPassword,
                doLoginWithGoogle,
                doLoginWithFacebook,
                doLogout
            }}>
            {children}
        </FirebaseContext.Provider>
    );
};

FirebaseProvider.propTypes = {
    children: PropTypes.node
};

export default FirebaseContext;